// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  maintenanceMode:false,

  //local
  // domain: "http://engineersaustralia.careerhive.com.au/",
  // SERVER: "http://localhost:3000/",
  // SERVER_URL: "http://localhost:3000/",


  //prod
  // domain: "https://engineersaustralia.careerhive.com.au/",
  // SERVER: "https://engineersaustraliaapi.careerhive.com.au/",
  // SERVER_URL: "https://engineersaustraliaapi.careerhive.com.au/",



  //dev
  // domain: "http://devengineersaustralia.careerhive.com.au/",
  // SERVER: "https://api.dev.engineersaustralia.careerhive.com.au/",
  // SERVER_URL: "https:/api.dev.engineersaustralia.careerhive.com.au/",

  //Test
  domain: "http://testengineersaustralia.careerhive.com.au/",
  SERVER: "https://api.test.engineersaustralia.careerhive.com.au/",
  SERVER_URL: "https:/api.test.engineersaustralia.careerhive.com.au/",

  tinyMCEApiKey: "zcwi1f81304uers1lcszh0iq2lbhcaxl5cj6ez0v89wr25z3"
};
